import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-130cafed")

_pushScopeId("data-v-130cafed")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (!_ctx.metadataError)
    ? (_openBlock(), _createBlock(_component_DataTable, {
        key: 0,
        class: "p-datatable-sm kn-table",
        value: _ctx.rule.ruleOutputs,
        dataKey: "id",
        responsiveLayout: "stack",
        breakpoint: "960px",
        "data-test": "metadata-table"
      }, {
        default: _withId(() => [
          _createVNode(_component_Column, {
            style: _ctx.metadataCardDescriptor.table.iconColumn.style
          }, {
            body: _withId((slotProps) => [
              (slotProps.data.aliasIcon)
                ? _withDirectives((_openBlock(), _createBlock("i", {
                    key: 0,
                    class: slotProps.data.aliasIcon
                  }, null, 2)), [
                    [
                      _directive_tooltip,
                      _ctx.alisIconTooltip(slotProps.data.aliasIcon),
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "alias",
            header: _ctx.$t('kpi.measureDefinition.alias')
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "type",
            header: _ctx.$t('kpi.measureDefinition.tipology')
          }, {
            body: _withId((slotProps) => [
              _createVNode(_component_Dropdown, {
                class: "metaweb-dropdown-field p-mr-2",
                modelValue: slotProps.data['type'],
                "onUpdate:modelValue": ($event: any) => (slotProps.data['type'] = $event),
                options: _ctx.tipologiesType,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('touched')))
              }, {
                value: _withId((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_1, [
                        _createVNode("span", null, _toDisplayString(slotProps.value['valueCd']), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                option: _withId((slotProps) => [
                  _createVNode("div", null, [
                    _createVNode("span", null, _toDisplayString(slotProps.option.valueCd), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "options"]),
              _hoisted_2
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('common.category')
          }, {
            body: _withId((slotProps) => [
              (slotProps.data['category'] && slotProps.data.type.valueCd != 'TEMPORAL_ATTRIBUTE')
                ? (_openBlock(), _createBlock(_component_AutoComplete, {
                    key: 0,
                    class: "metaweb-dropdown-field  p-mr-2",
                    modelValue: slotProps.data['category'].valueCd,
                    "onUpdate:modelValue": ($event: any) => (slotProps.data['category'].valueCd = $event),
                    suggestions: _ctx.filteredCategories,
                    field: "valueCd",
                    onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchCategories($event))),
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched'))),
                    onItemSelect: ($event: any) => (_ctx.setRuleCategory($event.value, slotProps.data))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions", "onItemSelect"]))
                : (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 1,
                    class: "metaweb-dropdown-field p-mr-2",
                    modelValue: slotProps.data['hierarchy'],
                    "onUpdate:modelValue": ($event: any) => (slotProps.data['hierarchy'] = $event),
                    options: _ctx.domainsTemporalLevel,
                    placeholder: _ctx.$t('kpi.measureDefinition.temporalAttributePlaceholder'),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('touched')))
                  }, {
                    value: _withId((slotProps) => [
                      (slotProps.value)
                        ? (_openBlock(), _createBlock("div", _hoisted_3, [
                            _createVNode("span", null, _toDisplayString(slotProps.value['valueCd']), 1)
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withId((slotProps) => [
                      _createVNode("div", null, [
                        _createVNode("span", null, _toDisplayString(slotProps.option.valueCd), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])),
              _hoisted_5
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value"]))
    : _createCommentVNode("", true)
})